// B1.4: employees domain methods (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class EmployeesApi extends ApiClientCore {
  async getEmployees(params: Record<string, any> = {}): Promise<any> {
    const q: Record<string, any> = { ...params };
    if (q.limit != null) {
      const n = Number(q.limit);
      if (Number.isFinite(n)) {
        q.limit = Math.min(200, Math.max(1, Math.floor(n)));
      }
    }
    return this.get(`/api/v1/employees${buildQueryString(q)}`);
  }
  async getEmployee(id: number): Promise<any> {
    return this.get(`/api/v1/employees/${id}`);
  }
  async createEmployee(data: any): Promise<any> {
    return this.post('/api/v1/employees', data);
  }
  async updateEmployee(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/employees/${id}`, data);
  }
  async deleteEmployee(id: number): Promise<any> {
    return this.request(`/api/v1/employees/${id}`, { method: 'DELETE' });
  }
  async restoreEmployee(id: number): Promise<any> {
    return this.post(`/api/v1/employees/${id}/restore`, {});
  }
  async getEmploymentAssignments(employeeId: number): Promise<any[]> {
    return this.get(`/api/v1/employment-assignments?employee_id=${employeeId}`);
  }
  async createEmploymentAssignment(data: {
    employee_id: number;
    position_id: number;
    is_primary?: boolean;
    effective_from?: string;
    effective_to?: string | null;
  }): Promise<any> {
    return this.post('/api/v1/employment-assignments', data);
  }
  async updateEmploymentAssignment(
    assignmentId: number,
    data: {
      position_id?: number | null;
      is_primary?: boolean;
      effective_from?: string;
      effective_to?: string | null;
    }
  ): Promise<any> {
    return this.patch(`/api/v1/employment-assignments/${assignmentId}`, data);
  }
  async deleteEmploymentAssignment(assignmentId: number): Promise<any> {
    return this.delete(`/api/v1/employment-assignments/${assignmentId}`);
  }
  // ─── Invites ────────────────────────────────────────────────────────────────
  async getInvites(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/invites${buildQueryString(params)}`);
  }
  async createInvite(data: any, options?: { replace?: boolean }): Promise<any> {
    const qs = options?.replace ? '?replace=true' : '';
    return this.post(`/api/v1/invites${qs}`, data);
  }
  async revokeInvite(id: number): Promise<any> {
    return this.post(`/api/v1/invites/${id}/revoke`, {});
  }
  async deleteInvite(id: number): Promise<any> {
    return this.request(`/api/v1/invites/${id}`, { method: 'DELETE' });
  }
  async getEmployeeAuthStatus(employeeId: number): Promise<{
    login_locked: boolean;
    retry_after_seconds: number;
    failure_count: number;
    email?: string | null;
  }> {
    return this.get(`/api/v1/employees/${employeeId}/auth-status`);
  }
  async resetEmployeeAuthLock(employeeId: number): Promise<{ ok: boolean; message: string }> {
    return this.post(`/api/v1/employees/${employeeId}/auth-lock-reset`, {});
  }
}
